import React from "react";
import { ClickableButton } from "../../../Atoms/Buttons";
import { useNavigate } from "react-router-dom";

export default function JobApplyCard(props) {
  const { requirements, experience, title } = props;
  const navigate = useNavigate()

  return (
    <div className="jobCard" style={{ border: "1px solid gray" }}>
      <div className="single-job-card">
        <div className="jobs-requirements">
          <div className="job-title">
            <h6 style={{ fontSize: "0.9rem", margin: 0, textAlign: "start" }}>
              {title}
            </h6>
          </div>

          <ul>
            <li>Required Technology: {requirements.join("/").split("")}</li>
            <li>Required Experience: {experience}</li>

            {/* {props.jobDetails.map((jobs) => (
              
            ))} */}
          </ul>
        </div>

        <div className="view-apply-btn">
       
          <button  className="clickable-btn" onClick={() => navigate("/login")} style={{ backgroundColor: "grey" }}>
            View Details
          </button>

          <button  className="clickable-btn" onClick={() => navigate("/login")} style={{ backgroundColor: "#3FA959" }}>
            Apply
          </button>
        </div>
      </div>
    </div>
  );
}
